import angular = require("angular");
import TPL = require("templates");
import {Config} from "../../config";

import {ManageGuestsController} from "../../modals/manageGuests";
import {ConfirmController} from "../../modals/confirm";

export class ActionItem {

  label;
  callback;

  static buildActionItem(label, key, callback): ActionItem {
    var result = new ActionItem();
    result.label = label;
    result.callback = callback;
    return result;
  }
}

export class ActionList extends Array<ActionItem> {

  returnList;

  constructor() {
    super();
    this.returnList;
  }


  static buildHostedActionList($location, $modal, session, eventId, notification, rootScope): ActionList {
    var result = new ActionList();

    result.push(ActionItem.buildActionItem(
      "MANAGE.ACTION_EDIT_EVENT", Config.upcoming,
      ()=> {
        $location.url(Config.events + "/" + eventId + '/edit');
      })
    );

    result.push(ActionItem.buildActionItem(
      "MANAGE.ACTION_MANAGE_GUESTS", Config.upcoming,
      ()=> {
        ManageGuestsController.open($modal, eventId);
      })
    );

    result.push(ActionItem.buildActionItem(
      "MANAGE.ACTION_CANCEL_EVENT", Config.upcoming,
      ()=> {
        var modalView = ConfirmController.openConfirmDeleteEventModal($modal,
          () => {
            // confirmCallback
            session.spinnerService.show("mainSpinner");
            session.deleteEvent(eventId).then(() => {
              modalView.dismiss();
              notification.success("Dinner deleted");

              session.loadHostedEvents();
              session.loadPastEvents();

              session.spinnerService.hide("mainSpinner");

              $location.url(Config.manage + "/" + Config.hosted);
            });
          },
          () => {
            // cancelCallback
            modalView.dismiss();

            $location.url(Config.manage + "/" + Config.hosted);
          })
      })
    );

    result.push(ActionItem.buildActionItem(
      "MANAGE.SEND_EMAIL_TO", Config.upcoming,
      ()=> {

        session.loadReservations(eventId).then((response) => {
          var list = response;
          if(list != null) {
            var returnList = "";
            angular.forEach(list, (reservation) => {
              if(reservation.state != 'rejected') {
                if (returnList !== ""){
                  returnList = returnList + ";" + reservation.profile.email;
                } else {
                  returnList = reservation.profile.email;
                }
              }
            });
            return returnList;
          }
        }).then((returnList) => {
          if (returnList === undefined) {
            notification.error("There aren't emails adresses!");
          } else {
            var link = "mailto:" + returnList;
            window.location.href = link;
          }
        });

      })
    );

    return result;
  }



  static buildAttendingActionList($location, $modal, session, eventId, notification, rootScope): ActionList {
    var result = new ActionList();

    result.push(ActionItem.buildActionItem(
      "MANAGE.ACTION_CANCEL_RESERVATION", Config.upcoming,
      ()=> {
        var modalView = ConfirmController.openConfirmDeleteReservationModal($modal,
          () => {
            // confirmCallback
            session.deleteReservation(eventId).then(() => {
              modalView.dismiss();
              notification.success("Reservation deleted");

              session.loadUpcomingEvents();
            });
          },
          () => {
            // cancelCallback
            modalView.dismiss();
          })
      })
    );

    if($location.$$path !== "/manage/past") {
      result.push(ActionItem.buildActionItem(
        "MANAGE.ACTION_INVITE_FRIENDS", Config.upcoming,
        ()=> {
          ManageGuestsController.open($modal, eventId);
        })
      );
    }

    return result;
  }

  static buildSavedActionList($location, $modal, session, eventId, notification, rootScope): ActionList {
    var result = new ActionList();

    result.push(ActionItem.buildActionItem(
      "MANAGE.ACTION_EDIT_DRAFT", Config.upcoming,
      ()=> {
        $location.url(Config.events + "/" + eventId + '/edit');
      })
    );

    result.push(ActionItem.buildActionItem(
      "MANAGE.ACTION_PUBLISH_DRAFT", Config.upcoming,
      ()=> {
        $location.url(Config.events + "/" + eventId + "/guests");
      })
    );

    result.push(ActionItem.buildActionItem(
      "MANAGE.ACTION_DELETE_DRAFT", Config.upcoming,
      ()=> {
        var modalView = ConfirmController.openConfirmDeleteEventModal($modal,
          () => {
            // confirmCallback
            session.deleteEvent(eventId).then(() => {
              modalView.dismiss();
              notification.success("Draft deleted");

              session.loadHostedEvents();
              session.loadPastEvents();

              $location.url(Config.manage + "/" + Config.hosted);
            });
          },
          () => {
            // cancelCallback
            modalView.dismiss();

            $location.url(Config.manage + "/" + Config.hosted);
          })
      })
    );


    return result;
  }
}


export class EventActionMenuDirective {

  template = TPL.contentDirectives.eventActionMenu;
  scope = {
    params: "=params"
  };
  link;

  constructor($location, $modal, session, notification, $rootScope) {

    this.link = (scope, el, attrs) => {

      var actionList;

      switch (scope.params.type) {
        case "saved":
          actionList = ActionList.buildSavedActionList($location, $modal, session, scope.params.item.uuid, notification, $rootScope);
          break;
        case "hosted":
          actionList = ActionList.buildHostedActionList($location, $modal, session, scope.params.item.uuid, notification, $rootScope);
          break;
        case "attending":
        default:
          actionList = ActionList.buildAttendingActionList($location, $modal, session, scope.params.item.uuid, notification, $rootScope);
      }

        scope.vm = {
          session: session,
          actionList: actionList,
        };
    }
  }

  static factory() {
    var tmp = (a, b, c, d, e) => new EventActionMenuDirective(a, b, c, d, e);
    tmp.$inject = ["$location", "$uibModal", "session", "Notification", "$rootScope"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/eventActionMenu.ts
 **/